import About from './About';
import Services from './Services';
import Products from './Products';
import Contact from './Contact';
import React from 'react';

function Main() {
  return (
    <>
      <main id="home">
        <Services />
        <Products />
        <About />
        <Contact />
      </main>
    </>
  );
}
export default Main;
